import React from "react";
import NOUHWebsite from "./pages/nouh";

import "./index.css";

export default function App() {
  return <NOUHWebsite />; // NOUHWebsite can use NavLink/useLocation safely now
}
